import { Contact } from '@/components/sections/contact';

export function ContactPage() {
  return (
    <div className="container">
      <Contact />
    </div>
  );
}